export enum Events {
  Consent = 'consent',
  PageView = 'pageView'
}
